import { defineStore } from "pinia";
import { apiCall } from "../utils/api";

export const useAdminStore = defineStore("admin", {
  state: () => ({
    admin: null,
    role: "",
    auth: [],
    accessToken: localStorage.getItem("accessToken") || "",
    expiresIn: localStorage.getItem("expiresIn") || "",
  }),
  getters: {
    isLoggedIn: (state) => !!state.accessToken,
  },
  actions: {
    async login(username, password) {
      const response = await apiCall("manager.login", {
        name: username,
        password,
      });
      if (!response) {
        return false;
      }
      this.accessToken = response.accessToken;
      this.expiresIn = response.expiresIn;
      this.admin = response.name;
      localStorage.setItem("accessToken", response.accessToken);
      localStorage.setItem("expiresIn", response.expiresIn);
      return true;
    },
    async getMe() {
      if (!this.accessToken) {
        return;
      }
      const response = await apiCall("manager.getMe", {});
      if (!response) {
        return false;
      }
      this.admin = response.name;
      this.role = response.role;
      this.auth = response.auth;
      return true;
    },
    async modifyPwd(password, newPassword) {
      const response = await apiCall("manager.modifyPwd", {
        password,
        newPassword,
      });
      if (!response) {
        return false;
      }
      return true;
    },
    logout() {
      this.accessToken = "";
      this.expiresIn = "";
      this.admin = null;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("expiresIn");
    },
  },
});
